import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { styled } from "@mui/material/styles";
import Discussion from "./Discussion";
import Summary from "./Summary";
import ContractFiles from "./ContractFiles";
import ContractRenewal from "./ContractRenewal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  "& .MuiTabs-indicatorSpan": {
    maxWidth: 40,
    width: "100%",
    backgroundColor: "#635ee7",
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: "#C0B476",
    "&.Mui-selected": {
      color: "#000000",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "red",
    },
  })
);
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function ContractView() {
  const [value, setValue] = React.useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const { id } = useParams();
  const handleChange = (event, newValue) => {
    if (newValue === 1) {
      navigate(`/work/contracts/${id}?tab=discussion`, { state });
    }
    if (newValue === 2) {
      navigate(`/work/contracts/${id}?tab=contract-files`, { state });
    }
    if (newValue === 3) {
      navigate(`/work/contracts/${id}?tab=contract-renewal-history`, { state });
    }
    if (newValue === 0) {
      navigate(`/work/contracts/${id}`, { state });
    }
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        maxWidth: "100%",
        background: "#fff",
        color: "black",
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <StyledTabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <StyledTab label="Summary" {...a11yProps(0)} />
          <StyledTab label="Discussion" {...a11yProps(1)} />
          <StyledTab label="Contract Files" {...a11yProps(2)} />
          <StyledTab label="Contract Renewal History" {...a11yProps(3)} />
        </StyledTabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Summary />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Discussion />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <ContractFiles />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <ContractRenewal />
      </CustomTabPanel>
    </Box>
  );
}

export default ContractView;
